<div
  aria-labelledby="headPrimary2"
  class="common-va-widget-bg"
  id="primaryPanel2"
  role="tabpanel"
>
  <div class="container checkin-widget-container container-padding-x">
    <form
      #formStoreDir="ngcFormStore"
      #ngCheckinWidgetForm
      (ngSubmit)="onSubmit($event)"
      [formGroup]="checkinWidgetForm"
      [makeVisible]="isSubmitted"
      [ngc-form-store]="'checkinWidgetForm'"
      [ngc-formNameToValidate]="'checkinWidgetForm'"
      [ngc-formToValidate]="checkinWidgetForm"
      autocomplete="off"
      method="POST"
      ngc-error-handler
    >
      <ngc-make-correction></ngc-make-correction>
      <input
        [(ngModel)]="credCardCode"
        [ngModelOptions]="{ standalone: true }"
        id="creditcardType"
        name="creditcardType"
        type="hidden"
      />
      <input name="startFrom" type="hidden" value="searchPage" />
      <div class="form-row align-items-start">
        <div
          *ngIf="deviceTypes.isDesktop"
          class="col-sm-12 offset-md-2 col-md-8 col-lg-4 offset-lg-0 select_dropdown pl-xl-0 pl-xxl-0"
        >
          <label class="sr-only" for="searchType">Find Your Trip By</label>
          <select
            #checkinByDropdown="ngcSelectDirective"
            (change)="selectTripType($event.target.value)"
            (customChangeEvent)="customChangeEventHandler($event)"
            [(ngModel)]="selectCheckinBy"
            [formControlName]="'searchType'"
            [ngc-floatinglabel]="
              contentCheckIn
                ? contentCheckIn.findYourTripBy
                : 'Find Your Trip By'
            "
            [selectedIndex]="getSelectedIndex()"
            autorotateoption="true"
            class="drop-down first-control form-control"
            customClassName="blue-theme"
            customClassNameFocus="focusable-element"
            customLoadingCheck="true"
            data-dluiSelect
            id="searchType"
            name="searchType"
            openonenter="true"
          >
            <option
              *ngFor="let checkinType of checkinBy"
              [value]="checkinType.value"
            >
              {{ checkinType.title }}
            </option>
          </select>
        </div>
        <div
          *ngIf="!deviceTypes.isDesktop"
          class="col-sm-12 offset-md-2 col-md-8 col-lg-4 offset-lg-0 select_dropdown pl-xxl-0 select-container-down-md"
        >
          <select
            (change)="selectTripType($event.target.value)"
            (customChangeEvent)="customChangeEventHandler($event)"
            [(ngModel)]="selectCheckinBy"
            [formControlName]="'searchType'"
            [ngc-floatinglabel]="
              contentCheckIn
                ? contentCheckIn.findYourTripBy
                : 'Find Your Trip By'
            "
            [selectedIndex]="getSelectedIndex()"
            class="drop-down first-control form-control"
            customClassName="blue-theme"
            id="searchType"
            name="searchType"
          >
            <option
              *ngFor="let checkinType of checkinBy"
              [value]="checkinType.value"
            >
              {{ checkinType.title }}
            </option>
          </select>
          <span class="icon-Dropdown-caret d-lg-none"></span>
        </div>

        <div
          *ngIf="selectCheckinBy === 'confirmationInput'"
          class="col-lg-3 col-sm-12 offset-md-2 col-md-8 offset-lg-0"
        >
          <input
            #confirmationNumber
            (focusout)="
              confirmationNumber.value = $event.target.value.toUpperCase()
            "
            [attr.placeholder]="
              contentCheckIn
                ? contentCheckIn.checkIn.get('confirmationInput').trackingNumber
                : 'ex. SFTORB'
            "
            [formControlName]="'confirmationNumber'"
            [ngc-floatinglabel]="
              contentCheckIn
                ? contentCheckIn.checkIn.get('confirmationInput')
                    .searchFloatLabelCheck
                : 'Confirmation No1'
            "
            [ngc-isRequired]="true"
            autocomplete="off"
            class="form-control mb-2 mb-sm-0 input-mobile-tab-class"
            id="confirmationNumber"
            name="confirmationNumber"
            type="{{
              contentCheckIn
                ? contentCheckIn.checkIn.get('confirmationInput')
                    .trackingNumberType
                : 'text'
            }}"
          />
          <a
            #checkinconfnoHelp="ngcHelpModalDirective"
            (click)="checkinconfnoHelp?.openHelpModal()"
            [helpContent]="contentCheckIn?.tooltips?.get('confirmation-number')"
            [type]="'checkinconfno'"
            aria-haspopup="true"
            class="checkin-ticketno-help icon-help circle-outline"
            draggable="false"
            href="javascript:void(0);"
            ngc-help-modal-directive
          >
            <span class="sr-only">Confirmation number help</span>
          </a>
          <ngc-validation-error-message
            [control]="checkinWidgetForm?.controls.confirmationNumber"
            [controlname]="'confirmationNumber'"
            [focusedFieldId]="'confirmationNumber'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
        </div>

        <div
          *ngIf="selectCheckinBy === 'eticketInput'"
          class="col-lg-3 col-sm-12 offset-md-2 col-md-8 offset-lg-0"
        >
          <input
            #eticketNumber
            (focusout)="eticketNumber.value = $event.target.value.toUpperCase()"
            [attr.placeholder]="
              contentCheckIn
                ? contentCheckIn.checkIn.get('eticketInput').trackingNumber
                : 'ex. 0062112549881'
            "
            [formControlName]="'eticketNumber'"
            [ngc-floatinglabel]="
              contentCheckIn
                ? contentCheckIn.checkIn.get('eticketInput')
                    .searchFloatLabelCheck
                : 'Ticket Number'
            "
            [ngc-isRequired]="true"
            autocomplete="off"
            class="form-control mb-2 mb-sm-0 input-mobile-tab-class"
            id="eticketNumber"
            name="eticketNumber"
            type="{{
              contentCheckIn
                ? contentCheckIn.checkIn.get('eticketInput').trackingNumberType
                : 'number'
            }}"
            pattern="{{ contentCheckIn?.checkInRegexPattern }}"
          />
          <a
            #checkinticketnoHelp="ngcHelpModalDirective"
            (click)="checkinticketnoHelp?.openHelpModal()"
            [helpContent]="contentCheckIn?.tooltips?.get('ticket-number')"
            [type]="'checkinticketno'"
            aria-haspopup="true"
            class="checkin-ticketno-help icon-help circle-outline"
            draggable="false"
            href="javascript:void(0);"
            ngc-help-modal-directive
          >
            <span class="sr-only">Ticket number help</span>
          </a>
          <ngc-validation-error-message
            [control]="checkinWidgetForm?.controls.eticketNumber"
            [controlname]="'eticketNumber'"
            [focusedFieldId]="'eticketNumber'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
        </div>
        <div
          *ngIf="selectCheckinBy === 'skymilesInput'"
          class="col-lg-3 col-sm-12 offset-md-2 col-md-8 offset-lg-0"
        >
          <input
            [attr.placeholder]="
              contentCheckIn
                ? contentCheckIn.checkIn.get('skymilesInput').trackingNumber
                : 'ex. 1234567890'
            "
            [formControlName]="'skymilesNumber'"
            [ngc-floatinglabel]="
              contentCheckIn
                ? contentCheckIn.checkIn.get('skymilesInput')
                    .searchFloatLabelCheck
                : 'SkyMiles Number'
            "
            [ngc-isRequired]="true"
            autocomplete="off"
            class="form-control mb-2 mb-sm-0 input-mobile-tab-class"
            id="skymilesNumber"
            name="skymilesNumber"
            type="{{
              contentCheckIn
                ? contentCheckIn.checkIn.get('skymilesInput').trackingNumberType
                : 'text'
            }}"
            pattern="{{ contentCheckIn?.checkInRegexPattern }}"
          />
          <ngc-validation-error-message
            [control]="checkinWidgetForm?.controls.skymilesNumber"
            [controlname]="'skymilesNumber'"
            [focusedFieldId]="'skymilesNumber'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
        </div>
        <div
          *ngIf="selectCheckinBy === 'creditCardInput'"
          class="col-lg-3 col-sm-12 offset-md-2 col-md-8 offset-lg-0"
        >
          <input
            (creditCardType)="creditCardTypeDetected($event)"
            [attr.placeholder]="
              contentCheckIn
                ? contentCheckIn.checkIn.get('creditCardInput').trackingNumber
                : 'ex. 1234123412341234'
            "
            [creditCardNumber]="
              checkinWidgetForm?.controls.creditcardNumber.value
            "
            [formControlName]="'creditcardNumber'"
            [ngc-floatinglabel]="
              contentCheckIn
                ? contentCheckIn.checkIn.get('creditCardInput')
                    .searchFloatLabelCheck
                : 'Credit Card Number'
            "
            [ngc-isRequired]="true"
            autocomplete="off"
            class="form-control mb-2 mb-sm-0 input-mobile-tab-class"
            credCardType
            id="creditcardNumber"
            name="creditcardNumber"
            type="{{
              contentCheckIn
                ? contentCheckIn.checkIn.get('creditCardInput')
                    .trackingNumberType
                : 'number'
            }}"
            pattern="{{ contentCheckIn?.checkInRegexPattern }}"
          />
          <ngc-validation-error-message
            [control]="checkinWidgetForm?.controls.creditcardNumber"
            [controlname]="'creditcardNumber'"
            [focusedFieldId]="'creditcardNumber'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
        </div>
        <div
          *ngIf="selectCheckinBy === 'creditCardInput'"
          [ngClass]="{ 'col-lg-2': selectCheckinBy === 'creditCardInput' }"
          class="col-lg-2 col-sm-12 offset-md-2 col-md-8 offset-lg-0"
        >
          <input
            #lastName
            [attr.placeholder]="
              contentCheckIn ? contentCheckIn.cinLastname : 'Last Name12'
            "
            [formControlName]="'lastName'"
            [ngc-floatinglabel]="
              contentCheckIn ? contentCheckIn.floatlabelLastname : 'Last Name'
            "
            [ngc-isRequired]="true"
            class="form-control mb-2 mb-sm-0 text-capitalize input-mobile-tab-class"
            id="lastName"
            name="lastName"
            type="text"
          />
          <ngc-validation-error-message
            [control]="checkinWidgetForm?.controls.lastName"
            [controlname]="'lastName'"
            [focusedFieldId]="'lastName'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
        </div>
        <div
          *ngIf="contentCheckIn?.whereToFindLabel"
          class="col-lg-4 resrv-link-col offset-md-2 col-md-8 col-sm-12 offset-lg-0 pl-xl-0 mt-lg-2 mb-lg-1 mt-md-4 mt-sm-4 d-none d-md-block d-sm-block d-lg-none"
        >
          <a
            [attr.href]="
              contentCheckIn
                ? contentCheckIn.whereToFindUrl
                : 'https://www.virginatlantic.com/'
            "
            [attr.target]="''"
            class="hotel-resrv-link icon-Dropdown-caret"
          >
            {{
              contentCheckIn
                ? contentCheckIn.whereToFindLabel
                : 'Where do I find my details?'
            }}
            <!-- <span class="sr-only">opens in new window</span> -->
          </a>
        </div>
        <div
          [ngClass]="{
            'col-lg-4': selectCheckinBy !== 'creditCardInput',
            'col-lg-2': selectCheckinBy === 'creditCardInput'
          }"
          class="col-sm-12 offset-md-2 col-md-8 offset-lg-0"
        >
          <a
            #deptAirportLookupDir="ngcAirportLookupDirective"
            (click)="deptAirportLookupDir?.openLookupModal(true)"
            (focusout)="markAsTouchedFrom()"
            (keydown)="
              $event.keyCode !== 13 &&
              (($event.keyCode >= 65 && $event.keyCode <= 90) ||
                ($event.keyCode >= 96 && $event.keyCode <= 105) ||
                ($event.keyCode >= 48 && $event.keyCode <= 57))
                ? deptAirportLookupDir?.openLookupModal(0)
                : ''
            "
            (searchedAirportCode)="fromAirport = $event"
            (selectedAirport)="fromAirport = $event.airportCode"
            [currentNav]="'Check-In'"
            [initialLookupKey]="
              fromAirport === 'From Airport' ? null : fromAirport
            "
            [lookupTitle]="'Origin'"
            [ngc-data-value]="
              fromAirport === 'From Airport' ? null : fromAirport
            "
            [ngc-floatinglabel]="
              contentCheckIn ? contentCheckIn.fromAirportFloat : 'From Airport'
            "
            [ngc-isRequired]="true"
            [ngc-useDataValue]="true"
            [widgetOnTop]="widgetOnTop"
            aria-haspopup="true"
            class="departCity form-control mb-2 mb-sm-0"
            href="javascript:void(0);"
            id="departureAirportLink"
            ngc-airport-lookup-directive
          >
            <input
              [(ngModel)]="fromAirport"
              [formControlName]="'departureAirport'"
              id="departureAirport"
              name="departureAirport"
              type="hidden"
            />
            <span class="sr-only">city</span>
            <span
              [ngClass]="{
                'airport-desc':
                  !fromAirport ||
                  fromAirport === '' ||
                  fromAirport === 'From Airport'
              }"
            >
              {{
                fromAirport && fromAirport !== ''
                  ? fromAirport
                  : contentCheckIn?.fromAirport
              }}
            </span>
            <span class="sr-only">Required</span>
          </a>
          <ngc-validation-error-message
            [control]="checkinWidgetForm?.controls.departureAirport"
            [controlname]="'departureAirport'"
            [focusedFieldId]="'departureAirportLink'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
        </div>
        <div
          *ngIf="contentCheckIn?.helpLabel"
          class="col-lg-4 resrv-link-col offset-md-2 col-md-4 col-sm-8 offset-lg-0 pl-xl-0 mt-md-3 mt-sm-3 mb-lg-1 ml-lg-3 mt-lg-2 ml-lg-3 d-none d-md-block d-sm-block d-lg-none"
        >
          <a
            [attr.href]="
              contentCheckIn
                ? contentCheckIn.helpUrl
                : 'https://www.virginatlantic.com/'
            "
            [attr.target]="''"
            class="hotel-resrv-link icon-Dropdown-caret"
          >
            {{ contentCheckIn ? contentCheckIn.helpLabel : 'Check-in help' }}
            <!-- <span class="sr-only">opens in new window</span> -->
          </a>
        </div>
        <div
          class="pr-lg-0 pr-xl-0 col-lg-1 col-md-8 offset-md-2 text-right mt-sm-4 mt-lg-4 mb-sm-4 offset-lg-0 mb-lg-2"
        >
          <button
            [ngClass]="{
              'last-focusable-element':
                contentCheckIn &&
                !whereToFocusEnable &&
                contentCheckIn &&
                !checkinHelpFocusEnable
            }"
            class="btn btn-danger btn-right-arrow icon-submitarrow rounded-circle circle-outline"
            id="btn-checkin-submit"
            type="submit"
          >
            <span class="sr-only">Submit</span>
          </button>
        </div>
      </div>
      <div class="form-row">
        <div
          *ngIf="contentCheckIn?.helpLabel"
          class="col-lg-4 resrv-link-col offset-md-2 col-md-8 col-sm-10 offset-lg-0 pl-xl-0 mt-lg-2 mb-lg-1 d-none d-lg-block"
        >
          <a
            [attr.href]="
              contentCheckIn
                ? contentCheckIn.helpUrl
                : 'https://www.virginatlantic.com/'
            "
            [attr.target]="''"
            [ngClass]="{
              'last-focusable-element':
                contentCheckIn && !whereToFocusEnable && checkinHelpFocusEnable
            }"
            class="hotel-resrv-link icon-Dropdown-caret"
          >
            {{ contentCheckIn ? contentCheckIn.helpLabel : 'Check-in help' }}
            <!-- <span class="sr-only">opens in new window</span> -->
          </a>
        </div>
        <div
          *ngIf="contentCheckIn?.whereToFindLabel"
          class="col-lg-4 resrv-link-col offset-md-2 col-md-8 col-sm-10 offset-lg-0 pl-xl-0 mb-lg-1 ml-lg-3 mt-lg-2 ml-lg-3 d-none d-lg-block"
        >
          <a
            [attr.href]="
              contentCheckIn
                ? contentCheckIn.whereToFindUrl
                : 'https://www.virginatlantic.com/'
            "
            [attr.target]="''"
            [ngClass]="{
              'last-focusable-element':
                contentCheckIn && whereToFocusEnable && checkinHelpFocusEnable
            }"
            class="hotel-resrv-link icon-Dropdown-caret"
          >
            {{
              contentCheckIn
                ? contentCheckIn.whereToFindLabel
                : 'Where do I find my details?'
            }}
            <!-- <span class="sr-only">opens in new window</span> -->
          </a>
        </div>
      </div>
    </form>
  </div>
</div>
